var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"title":_vm.Core.Definition.getDefinition('PDF'),"hide-footer":true},model:{value:(_vm.dataShow),callback:function ($$v) {_vm.dataShow=$$v},expression:"dataShow"}},[_c('DynamicForm',{ref:"dynamicForm",attrs:{"ignoreRouteParamId":true,"getRoot":"/binder-pdf","saveRoot":"/binder-pdf","options":_vm.dataOptions,"formStructure":_vm.dataFormStructures.form},on:{"onInit":_vm.onInit,"onSave":_vm.onSave,"onInitSuccess":_vm.onInitSuccess,"onRequestSuccess":_vm.onRequestSuccess,"onSaveSuccess":_vm.onSaveSuccess},model:{value:(_vm.dataId),callback:function ($$v) {_vm.dataId=$$v},expression:"dataId"}},[_vm._t("default",[_c('InputMultipleInstanceSelector',{ref:"modalInstanceSelector",attrs:{"emptyMessage":_vm.Core.Definition.getDefinition('Tous les indexes seront ajoutés au PDF'),"description":_vm.Core.Definition.getDefinition('Indexes'),"searchArgs":_vm.binderIndexSearchArgs,"instanceSelector":{
                    root: '/binder-index/list',
                    searchFormStructure: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'title'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: _vm.Core.Definition.getDefinition('Titre'),
                                value: ''
                            }
                        ]
                    },
                    data: {},
                    options: {
                        pagination: true,
                        header: true,
                        responsive: false,
                        striped: true,
                        headerStyle: '1',
                        emptyText: _vm.Core.Definition.getDefinition('Aucun élément à afficher'),
                        borderVariant: 'white',
                        noBody: true
                    },
                    columns: [
                                    {
                                        label: _vm.Core.Definition.getDefinition('#'),
                                        key: 'id',
                                        sortable: true
                                    },
                                    {
                                        label: _vm.Core.Definition.getDefinition('Titre'),
                                        key: 'title',
                                        sortable: true
                                    }
                    ],
                    label: 'title',
                    id: 'id'
                }},model:{value:(_vm.dataBinderIndexes),callback:function ($$v) {_vm.dataBinderIndexes=$$v},expression:"dataBinderIndexes"}}),(_vm.dataBinderIndexes.length > 0)?_c('InputMultipleInstanceSelector',{ref:"modalInstanceSelector",attrs:{"emptyMessage":_vm.Core.Definition.getDefinition('Tous les formulaires des indexes sélectionnés seront ajoutés au PDF'),"description":_vm.Core.Definition.getDefinition('Formulaires'),"searchArgs":_vm.binderFormSearchArgs,"instanceSelector":{
                    root: '/binder-form/list',
                    searchFormStructure: {
                        rows: [
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'title'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: _vm.Core.Definition.getDefinition('Titre'),
                                value: ''
                            }
                        ]
                    },
                    data: {},
                    options: {
                        pagination: true,
                        header: true,
                        responsive: false,
                        striped: true,
                        headerStyle: '1',
                        emptyText: _vm.Core.Definition.getDefinition('Aucun élément à afficher'),
                        borderVariant: 'white',
                        noBody: true
                    },
                    columns: [
                                    {
                                        label: _vm.Core.Definition.getDefinition('#'),
                                        key: 'id',
                                        sortable: true
                                    },
                                    {
                                        label: _vm.Core.Definition.getDefinition('Titre'),
                                        key: 'title',
                                        sortable: true
                                    }
                    ],
                    label: 'title',
                    id: 'id'
                }},model:{value:(_vm.dataBinderForms),callback:function ($$v) {_vm.dataBinderForms=$$v},expression:"dataBinderForms"}}):_vm._e(),_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_vm._v("\n                "+_vm._s(_vm.Core.Definition.getDefinition('Cette opération peu prendre plusieurs minutes. Vous pourrez continuer à travailler durant le processus de création du PDF. Vous recevrez une notification lorsque le document sera prêt.'))+"\n            ")])],{"slot":"afterForm"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }